import { GENDER, POSSESSIVE_PRONOUN, getHisHer } from '@demandproai/shared';

const GENDER_NORMALIZATION_MAP = {
  [String(GENDER.MALE).toLowerCase()]: GENDER.MALE,
  [String(GENDER.FEMALE).toLowerCase()]: GENDER.FEMALE
};

export const normalizeGender = (genderStr) => {
  const value = (genderStr || '').trim().toLowerCase();
  return GENDER_NORMALIZATION_MAP[value] || null;
};

export const getPossessivePronoun = (gender) => {
  const normalizedGender = normalizeGender(gender);
  if (!normalizedGender) return POSSESSIVE_PRONOUN.NEUTRAL;
  return getHisHer(false, normalizedGender === GENDER.MALE);
};
